module.exports = __webpack_public_path__ + "img/605-42dfb3.png";